import {
  createAsyncThunk,
  createSlice
} from "@reduxjs/toolkit";
import { handleResponse } from "@/services/axios";
import myTaskService from "@/services/api/mytask";

interface LoadingState {
  taskDetails: boolean;
  assignedByMe: boolean;
  taskOwner: boolean;
  updateStatus: boolean;
  taskDetailById: boolean;
  taskDelete: boolean;
  taskComment: boolean;
  comment: boolean;
  companyMember:boolean;
  taskAdd:boolean;
  taskUpdate:boolean;
}

interface TaskState {
  taskDetails: any;
  taskDetailById: any;
  error: string | null;
  loading: LoadingState;
  assignedByMe: any;
  taskOwner: any;
  updateStatus: any;
  taskDelete: any;
  taskComment: any;
  comment: any;
  companyMember:any;
  taskAdd:any;
  taskUpdate:any;

}

const initialState: TaskState = {
  taskDetails: [],
  taskDetailById: [],
  assignedByMe: [],
  taskOwner: [],
  updateStatus: [],
  error: null,
  taskDelete: [],
  taskComment: [],
  comment: [],
  companyMember:[],
  taskAdd:[],
  taskUpdate:[],
  loading: {
    taskDetails: false,
    assignedByMe: false,
    taskOwner: false,
    updateStatus: false,
    taskDetailById: false,
    taskDelete: false,
    taskComment: false,
    comment: false,
    companyMember:false,
    taskAdd:false,
    taskUpdate:false,
  },
};

export const getTaskDetails = createAsyncThunk(
  "task/getTaskDetails",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getTaskDetails(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch task details"
      );
    }
  }
);

export const getTaskAssignedByMe = createAsyncThunk(
  "task/getTaskAssignedByMe",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getTaskAssignedByMe(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch  assigned task details"
      );
    }
  }
);

export const getTaskOwners = createAsyncThunk(
  "task/getTaskOwners",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getTaskOwners(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch task owner"
      );
    }
  }
);

export const updateTaskStatus = createAsyncThunk(
  "task/updateTaskStatus",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.updateTaskStatus(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch update task status"
      );
    }
  }
);

export const getTaskDetailById = createAsyncThunk(
  "task/getTaskDetailById",
  async (taskId: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getTaskDetailById(taskId);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch task detail"
      );
    }
  }
);

export const undoTask = createAsyncThunk(
  "task/undoTask",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.undoTask(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to undo task"
      );
    }
  }
);

export const deleteTask = createAsyncThunk(
  "task/deleteTask",
  async (taskId: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.deleteTask(taskId);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to delete task"
      );
    }
  }
);

export const getTaskComment = createAsyncThunk(
  "task/getTaskComment",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getTaskComment(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch task comments"
      );
    }
  }
);

export const commentOnTask = createAsyncThunk(
  "task/commentOnTask",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.commentOnTask(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to add comment"
      );
    }
  }
);

export const getCompanyMembers = createAsyncThunk(
  "task/getCompanyMembers",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.getCompanyMembers(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to get member"
      );
    }
  }
);

export const addTask = createAsyncThunk(
  "task/addTask",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.addTask(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to add Task"
      );
    }
  }
);
export const taskDocumentUpload = createAsyncThunk(
  "task/addTask",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.taskDocumentUpload(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to upload Task"
      );
    }
  }
);

export const updateTask = createAsyncThunk(
  "task/updateTask",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await myTaskService.updateTask(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to add Task"
      );
    }
  }
);

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(getTaskDetails.pending, (state) => {
        state.loading.taskDetails = true;
        state.error = null;
        state.taskDetails = [];
      })
      .addCase(getTaskDetails.fulfilled, (state, action) => {
        state.loading.taskDetails = false;
        state.taskDetails = action.payload || [];
      })
      .addCase(getTaskDetails.rejected, (state, action) => {
        state.loading.taskDetails = false;
        state.error = action.payload as string;
      })

      .addCase(getTaskAssignedByMe.pending, (state) => {
        state.loading.assignedByMe = true;
        state.error = null;
        state.assignedByMe = [];
      })
      .addCase(getTaskAssignedByMe.fulfilled, (state, action) => {
        state.loading.assignedByMe = false;
        state.assignedByMe = action.payload || [];
      })
      .addCase(getTaskAssignedByMe.rejected, (state, action) => {
        state.loading.assignedByMe = false;
        state.error = action.payload as string;
      })

      .addCase(getTaskOwners.pending, (state) => {
        state.loading.taskOwner = true;
        state.error = null;
        state.taskOwner = [];
      })
      .addCase(getTaskOwners.fulfilled, (state, action) => {
        state.loading.taskOwner = false;
        state.taskOwner = action.payload || [];
      })
      .addCase(getTaskOwners.rejected, (state, action) => {
        state.loading.taskOwner = false;
        state.error = action.payload as string;
      })

      .addCase(updateTaskStatus.pending, (state) => {
        state.loading.updateStatus = true;
        state.error = null;
        state.updateStatus = [];
      })
      .addCase(updateTaskStatus.fulfilled, (state, action) => {
        state.loading.updateStatus = false;
        state.updateStatus = action.payload || [];
      })
      .addCase(updateTaskStatus.rejected, (state, action) => {
        state.loading.updateStatus = false;
        state.error = action.payload as string;
      })

      .addCase(getTaskDetailById.pending, (state, action) => {
        state.loading.taskDetailById = true;
        state.error = null;
        const requestedId = Number(action.meta.arg);
        const currentId = Number(
          state.taskDetailById?.Id ?? state.taskDetailById?.TaskId ?? 0,
        );
        if (!state.taskDetailById || currentId !== requestedId) {
          state.taskDetailById = null;
        }
      })
      .addCase(getTaskDetailById.fulfilled, (state, action) => {
        state.loading.taskDetailById = false;
        state.taskDetailById = action.payload || null;
      })
      .addCase(getTaskDetailById.rejected, (state, action) => {
        state.loading.taskDetailById = false;
        state.error = action.payload as string;
      })

      .addCase(deleteTask.pending, (state) => {
        state.loading.taskDelete = true;
        state.error = null;
        state.taskDelete = [];
      })
      .addCase(deleteTask.fulfilled, (state, action) => {
        state.loading.taskDelete = false;
        state.taskDelete = action.payload || [];
      })
      .addCase(deleteTask.rejected, (state, action) => {
        state.loading.taskDelete = false;
        state.error = action.payload as string;
      })

      .addCase(getTaskComment.pending, (state) => {
        state.loading.taskComment = true;
        state.error = null;
        state.taskComment = [];
      })
      .addCase(getTaskComment.fulfilled, (state, action) => {
        state.loading.taskComment = false;
        state.taskComment = action.payload || [];
      })
      .addCase(getTaskComment.rejected, (state, action) => {
        state.loading.taskComment = false;
        state.error = action.payload as string;
      })

      .addCase(commentOnTask.pending, (state) => {
        state.loading.comment = true;
        state.error = null;
        state.taskComment = [];
      })
      .addCase(commentOnTask.fulfilled, (state, action) => {
        state.loading.comment = false;
        state.taskComment = action.payload || [];
      })

      .addCase(commentOnTask.rejected, (state, action) => {
        state.loading.comment = false;
        state.error = action.payload as string;
      })

      .addCase(getCompanyMembers.pending, (state) => {
        state.loading.companyMember = true;
        state.error = null;
        state.companyMember = [];
      })
      .addCase(getCompanyMembers.fulfilled, (state, action) => {
        state.loading.companyMember = false;
        state.companyMember = action.payload || [];
      })

      .addCase(getCompanyMembers.rejected, (state, action) => {
        state.loading.companyMember = false;
        state.error = action.payload as string;
      })

      .addCase(addTask.pending, (state) => {
        state.loading.taskAdd = true;
        state.error = null;
        state.taskAdd = [];
      })
      .addCase(addTask.fulfilled, (state, action) => {
        state.loading.taskAdd = false;
        state.taskAdd = action.payload || [];
      })

      .addCase(addTask.rejected, (state, action) => {
        state.loading.taskAdd = false;
        state.error = action.payload as string;
      })

      .addCase(updateTask.pending, (state) => {
        state.loading.taskUpdate = true;
        state.error = null;
        state.taskUpdate = [];
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.loading.taskUpdate = false;
        state.taskUpdate = action.payload || [];
      })

      .addCase(updateTask.rejected, (state, action) => {
        state.loading.taskUpdate = false;
        state.error = action.payload as string;
      });

  },
});

export default taskSlice.reducer;